import styled from 'styled-components';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const DescriptionText = styled.p`
    color: rgba(58, 57, 57, 1);
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Montserrat';
    margin-top: 10px;
    padding: 0% 8%;
`;

const StyleDescription = styled.p`
    color: rgba(58, 57, 57, 1);
    text-align: center;
    font-weight: 500;
    font-size: 10px;
    font-family: 'Montserrat';
    width: 310px;
    // margin-top: 20px;  /* Uncomment when the text is in below of button */
    // margin-bottom: 0; /* Remove when the text is in below the button */
`;

const OptionText = styled.p`
    color: rgba(41, 37, 97, 1);
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    font-family: 'Montserrat';
    margin-top: 20px;
    padding: 0 10%;
`;

const NoButton = styled.button`
    background: rgba(176, 206, 251, 1);
    color: rgba(58, 57, 57, 1);
    font-family: 'Montserrat';
    font-weight: 500;
    border: none;
    border-radius: 20px;
    padding: 20px 30px;
    width: 300px;
    font-size: 12px;
    cursor: pointer;
    margin-bottom: 10px;
    // margin-top: 10px; /* Space between Yes and No buttons */
    &:hover {
        background: rgb(128, 191, 255, 0.8);
    }
`;

const YesButton = styled.button`
    background: rgba(186, 29, 29, 1);
    color: white;
    font-family: 'Montserrat';
    border: none;
    border-radius: 20px;
    padding: 15px 30px;
    width: 300px;
    font-size: 12px; /* Adjusted font size */
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 10px;
    &:hover {
        background: rgba(186, 29, 29, 0.8);
    }
`;

const StyledModalHeader = styled.h2`
    background: rgb(234, 222, 208, 1);
    color: rgba(41, 37, 97, 1);
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    font-family: 'Montserrat';
    padding-top: 10px;
    margin: 0;
`;

const StyledModalBody = styled.div`
    background: rgb(234, 222, 208, 1);
    color: rgba(41, 37, 97, 1) !important;
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    font-family: 'Montserrat';
    padding-top: 10px;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const MySwal = withReactContent(Swal);

export default function modalOptToUpload(handleClientSelection) {
    MySwal.fire({
        html: (
            <StyledModalBody>
                <StyledModalHeader>Upload Your Supporting Documents</StyledModalHeader>
                <DescriptionText>
                    Ang pag-submit ng additional documents ngayon ay maaaring makatulong sa amin na masimulan agad ang
                    pagproseso ng inyong claim. Kasama dito ang mga resibo, photos, police reports, atbp.
                </DescriptionText>
                <OptionText>Gusto mo bang i-upload and documents ngayon?</OptionText>
                <ButtonWrapper>
                    <StyleDescription>
                        Pwede mong tapusin ang iyong claim notification at bumalik nalang para i-upload ang documents.
                    </StyleDescription>
                    <NoButton onClick={() => handleClientSelection()}><strong>Not yet</strong>. I'll upload later</NoButton>
                    <YesButton onClick={() => handleClientSelection('upload_documents')}>
                        <strong>Yes</strong>, I want to upload my supporting documents
                    </YesButton>
                </ButtonWrapper>
            </StyledModalBody>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: {
            popup: 'my-popup',
            closeButton: 'my-close-button'
        },
        backdrop: `
            rgba(159, 159, 159, 0.5)
        `,
        allowOutsideClick: false,
        allowEscapeKey: false
    });
}
